<div class="container mt-4">
  <h2 class="mb-4">Work Order Status Update</h2>

  <table class="table table-bordered table-striped align-middle">
    <thead class="table-light">
      <tr>
        <th>WO #</th>
        <th>Company Name</th>
        <th>PO No</th>
        <th *ngIf="canEditInvoice">Invoice</th>
        <th *ngIf="canEditSticker">Sticker</th>
        <th *ngIf="canEditTC">TC</th>
        <th *ngIf="canEditOperations">Operations</th>
        <th>Remark</th>
        <th>Action</th>
      </tr>
      <tr>
        <th>
          <input type="text" class="form-control form-control-sm" placeholder="Search WO #" [(ngModel)]="filter.woId"
            (input)="applyFilters()" />
        </th>
        <th>
          <input type="text" class="form-control form-control-sm" placeholder="Search Company"
            [(ngModel)]="filter.workOrderCompany" (input)="applyFilters()" />
        </th>
        <th>
          <input type="text" class="form-control form-control-sm" placeholder="Search PO #" [(ngModel)]="filter.poId"
            (input)="applyFilters()" />
        </th>
        <th *ngIf="canEditInvoice">
          <div class="d-flex flex-column">
            <select class="form-select form-select-sm mb-2" [(ngModel)]="filter.invoiceStatus"
              (change)="applyFilters()">
              <option value="">All</option>
              <option value="NoValue">No Value</option>
              <option value="WithValue">With Value</option>
            </select>

            <input *ngIf="filter.invoiceStatus === 'WithValue'" type="text" class="form-control form-control-sm"
              placeholder="Enter Invoice Value" [(ngModel)]="filter.invoiceValue" (input)="applyFilters()" />
          </div>
        </th>


        <th *ngIf="canEditSticker">
          <div class="d-flex flex-column">
            <select class="form-select form-select-sm mb-2" [(ngModel)]="filter.stickerStatus"
              (change)="applyFilters()">
              <option value="">All</option>
              <option value="NoValue">No Value</option>
              <option value="WithValue">With Value</option>
            </select>
            <input *ngIf="filter.stickerStatus === 'WithValue'" type="text" class="form-control form-control-sm"
              placeholder="Enter Sticker Value" [(ngModel)]="filter.stickerValue" (input)="applyFilters()" />
          </div>
        </th>

        <th *ngIf="canEditTC">
          <div class="d-flex flex-column">
            <select class="form-select form-select-sm mb-2" [(ngModel)]="filter.tcStatus" (change)="applyFilters()">
              <option value="">All</option>
              <option value="NoValue">No Value</option>
              <option value="WithValue">With Value</option>
            </select>
            <input *ngIf="filter.tcStatus === 'WithValue'" type="text" class="form-control form-control-sm"
              placeholder="Enter TC Value" [(ngModel)]="filter.tcValue" (input)="applyFilters()" />
          </div>
        </th>

        <th *ngIf="canEditOperations">
          <div class="d-flex flex-column">
            <select class="form-select form-select-sm mb-2" [(ngModel)]="filter.operationsStatus"
              (change)="applyFilters()">
              <option value="">All</option>
              <option value="NoValue">No Value</option>
              <option value="WithValue">With Value</option>
            </select>
            <input *ngIf="filter.operationsStatus === 'WithValue'" type="text" class="form-control form-control-sm"
              placeholder="Enter Operations Value" [(ngModel)]="filter.operationsValue" (input)="applyFilters()" />
          </div>
        </th>

        <th>
          <input type="text" class="form-control form-control-sm" placeholder="Search Remarks"
            [(ngModel)]="filter.remarks" (input)="applyFilters()" />
        </th>
        <th>
          <button (click)="resetFilters()" class="btn btn-primary btn-sm">
            <i class="fa fa-x" aria-hidden="true"></i>
          </button>
        </th>
      </tr>

    </thead>
    <tbody>
      <tr *ngFor="let wo of filteredWorkOrders" [class.highlighted]="wo.workOrderNumber === highlightWoNumber"
        [attr.data-wo]="wo.workOrderNumber">

        <td>{{ wo.workOrderNumber }}</td>
        <td>{{ workOrderCommonServices.getClientName(wo.workOrderCompanyId)?.companyName || '-' }}</td>
        <td>{{ wo.purchaseOrderNumber || '-' }}</td>

        <td *ngIf="canEditInvoice">
          <input type="text" class="form-control form-control-sm" [(ngModel)]="wo.invoiceUpdatedBy"
            placeholder="Invoice Updated By">
        </td>

        <td *ngIf="canEditSticker">
          <input type="text" class="form-control form-control-sm" [(ngModel)]="wo.stickerUpdatedBy"
            placeholder="Sticker Updated By">
        </td>

        <td *ngIf="canEditTC">
          <input type="text" class="form-control form-control-sm" [(ngModel)]="wo.tcUpdatedBy"
            placeholder="TC Updated By">
        </td>

        <td *ngIf="canEditOperations">
          <input type="text" class="form-control form-control-sm" [(ngModel)]="wo.operationsUpdatedBy"
            placeholder="Operations Updated By">
        </td>

        <td>
          <textarea type="text" class="form-control auto-resize" [(ngModel)]="wo.remarks" rows="1"
            placeholder="Remark" (input)="autoResize($event)"></textarea>
        </td>

        <td>
          <button class="btn btn-sm btn-success" (click)="saveStatus(wo)">
            <i class="fa fa-save"></i>
          </button>
        </td>
      </tr>

    </tbody>
  </table>
</div>